import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=3d25a6b3&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "../assets/scss/dashboard.scss?vue&type=style&index=0&id=3d25a6b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d25a6b3",
  null
  
)

export default component.exports